exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".undefined-option{color:var(--fts-gray-5)}", ""]);

// exports
